import type { ExternalSyncStatus } from '../../hooks/useExternalSyncStatus';
import { cn } from '../../lib/utils';
import { SyncStatusBadge } from './SyncStatusBadge';

interface ProviderSyncStatusProps {
  syncStatus: ExternalSyncStatus | null;
  providerName: 'hubspot' | 'sumsub';
  className?: string;
}

export function ProviderSyncStatus({
  syncStatus,
  providerName,
  className,
}: ProviderSyncStatusProps) {
  const cardClassName = cn(
    'bg-neutral-900/40 rounded-lg border border-neutral-800/60 px-4 py-3',
    className,
  );

  if (!syncStatus) {
    return (
      <div className={cardClassName} aria-hidden="true">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              <div className="size-4 rounded-full bg-neutral-700/70 animate-pulse" />
              <div className="h-3.5 w-16 rounded bg-neutral-700/70 animate-pulse" />
            </div>
            <div className="size-1 rounded-full bg-neutral-700" />
            <div className="h-3.5 w-20 rounded bg-neutral-700/70 animate-pulse" />
          </div>
          <div className="h-3 w-20 rounded bg-neutral-700/70 animate-pulse" />
        </div>
      </div>
    );
  }

  const provider = syncStatus.providers.find(
    (p) => p.provider === providerName,
  );

  return (
    <div className={cardClassName}>
      <SyncStatusBadge
        provider={provider?.provider || providerName}
        status={provider?.lastSyncStatus || null}
        lastSyncTimestamp={provider?.lastSyncTimestamp || null}
        errorMessage={provider?.errorMessage || null}
      />
    </div>
  );
}
